export function isSmartSearch(object) {
    return 'query' in object;
}
export function isRegularSearch(object) {
    return 'profile' in object;
}
//# sourceMappingURL=user-types.js.map